<template>
    <v-main>

        <div class="credenciamento-header">
          <div class="icons1">
            <img src="@/assets/dentista-m.png" alt="Ícone 1" />
          </div>
          <div class="icons2">
              <img src="@/assets/dentista-f.png" alt="Ícone 2" />
          </div>
          <div class="text-content">
            <p class="text-left new-fonttittle">Credenciamento</p>
            <p class="text-left new-subfonttittle">
              Preencha os dados abaixo para prosseguir com o credenciamento.
            </p>
          </div>
        </div>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-container class="mt-0" >
          <v-card class="mx-auto my-8 pa-15 meu-container " outlined max-width="1080">
            <v-row>
              <v-col cols="12" md="12">
                <v-radio-group
                  @change="toogleDocumento"
                  v-model="tipoDocumento"
                  mandatory
                  row
                  class="custom-radio"
                >
                  <v-radio
                    label="Pessoa Física"
                    value="F"
                    class = "radio-label-custom"
                  ></v-radio>
                  <v-radio
                    label="Pessoa Jurídica"
                    value="J"
                    class = "radio-label-custom"
                  ></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="4"
                v-show="tipoDocumento == 'F'"
                class="py-0"
              >
                <v-text-field
                  class="cpf-style"
                  outlined
                  v-model="nrCpf"
                  @input="hideEspec"
                  :rules="regrasCpf"
                  inputmode="numeric"
                  :counter="14"
                  v-mask="'###.###.###-##'"
                  placeholder="___.___.___-__"
                  prepend-inner-icon="account_box"
                  label="*CPF"
                  @keyup.enter="validate"
                  required
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="4"
                v-show="tipoDocumento == 'J'"
                class="py-0"
              >
                <v-text-field
                  class="cpf-style"
                  outlined
                  v-model="nrCnpj"
                  @input="hideEspec"
                  :rules="regrasCnpj"
                  inputmode="text"
                  :counter="18"
                  v-mask="'XX.XXX.XXX/XXXX-XX'"
                  placeholder="__.___.___/____-__"
                  label="*CNPJ"
                  @keyup.enter="validate"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <v-text-field
                  class="cpf-style"
                  outlined
                  v-model="cep"
                  @input="hideEspec"
                  :rules="regrasCep"
                  inputmode="numeric"
                  :counter="9"
                  v-mask="'#####-###'"
                  placeholder="_____-___"
                  prepend-inner-icon="place"
                  label="*CEP do consultório"
                  @keyup.enter="validate"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4" class="py-0">
                <v-text-field
                  class="cpf-style"
                  outlined
                  v-model="dataNasc"
                  @input="hideEspec"
                  :rules="regrasDataNasc"
                  inputmode="numeric"
                  :counter="10"
                  v-mask="'##/##/####'"
                  placeholder="__/__/____"
                  prepend-inner-icon="event"
                  @keyup.enter="validate"
                  required
                >
                  <template v-slot:label>
                    <div>
                      *Data nascimento
                      {{ tipoDocumento == 'F' ? '' : 'responsavel técnico' }}
                    </div>
                  </template>
                </v-text-field>
              </v-col>
              <transition name="fade">
                <v-container v-show="mostrarEpec" class="container">
                  <v-row>
                    <v-col cols="12" md="5">
                      <v-select
                        v-model="tipoClinica"
                        :items="listaTipoClinica"
                        outlined
                        label="Tipo de Clí­nica"
                        @change="acertaEspecialidades"
                        item-text="valor"
                        item-value="codigo"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="7">
                      <v-chip
                        v-if="tipoClinica != 1"
                        class="ma-2"
                        color="yellow"
                        ><i class="fas mr-2 fa-exclamation-triangle"></i> A
                        análise do seu credenciamento será para Clínica
                        {{
                          tipoClinica == 2 ? 'de Emergência' : 'Radiológica'
                        }}.</v-chip
                      >
                    </v-col>
                  </v-row>
                  <v-col cols="12" md="12" class="componentEspec">
                    <p>
                      *Especialidades atendidas
                      <v-chip
                        v-if="erroEspecialidade"
                        class="ma-2"
                        color="red"
                        text-color="white"
                        ><i class="fas mr-2 fa-exclamation-triangle"></i>
                        Selecione ao menos 1 especialidade e seu grau de
                        instrução</v-chip
                      >
                    </p>
                    <v-simple-table
                      fixed-header
                      :height="tipoClinica == 1 ? '490px' : '120px'"
                      class="elevation-1"
                    >
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th id="idEspecialidades4">Especialidades</th>
                            <th id="idAreaDeAtuacao4">Área de atuação</th>
                            <th id="idEspecialista4">Especialista</th>
                            <th id="idGrauInstrucao4"
                              v-if="
                                especialidades.find(
                                  (x) => x.valorSelecionado === 'E'
                                )
                              "
                            >
                              Grau Instrução
                            </th>
                            <th id="idEspaco41" v-else></th>
                            <th id="idCertificado4"
                              v-if="
                                especialidades.find(
                                  (x) => x.valorSelecionado === 'E'
                                )
                              "
                            >
                              Certificado
                            </th>
                            <th id="idEspaco42" v-else></th>
                            <th id="idEspaco43"></th>
                          </tr>
                        </thead>
                        <tbody
                          v-for="(espec, i) in especialidades"
                          :key="'E' + i"
                        >
                          <tr>
                            <td>{{ espec.titulo }}</td>
                            <td>
                              <v-radio-group v-model="espec.valorSelecionado"
                                ><v-radio value="AA"></v-radio
                              ></v-radio-group>
                            </td>
                            <td>
                              <v-radio-group
                                v-if="espec.titulo != 'Clínica Geral'"
                                @change="handleRadioEspecialidadesChange(espec)"
                                v-model="espec.valorSelecionado"
                                ><v-radio value="E"></v-radio
                              ></v-radio-group>
                            </td>
                            <td>
                              <v-select
                                ref="selectGrauInstrucao"
                                v-if="espec.valorSelecionado == 'E'"
                                v-model="espec.grauInstrucao"
                                :items="listaGrauInstrucao"
                                item-text="valor"
                                item-value="codigo"
                                :rules="[obrigatorio]"
                                placeholder="*Selecione..."
                              ></v-select>
                            </td>
                            <td>
                              <v-file-input
                                v-if="espec.valorSelecionado == 'E'"
                                @change="convertBase64(espec)"
                                :loading="espec.loading"
                                accept="image/png, image/jpeg"
                                v-model="espec.certificado"
                                placeholder="Anexar certificado (opcional)"
                                counter
                                truncate-length="20"
                                :rules="[
                                  (value) =>
                                    !value ||
                                    value.size < 5000000 ||
                                    'Tamanho da imagem deve ser menor que 5 MB!',
                                  (value) =>
                                    value && !value.type.includes('image')
                                      ? 'Formato do arquivo é inválido'
                                      : true,
                                ]"
                              />
                            </td>
                            <td>
                              <v-tooltip
                                top
                                v-if="espec.valorSelecionado != null"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="
                                      espec.valorSelecionado = null;
                                      espec.grauInstrucao = null;
                                      espec.certificado = null;
                                    "
                                    icon
                                    color="primary"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <i class="fas fa-trash"></i>
                                  </v-btn>
                                </template>
                                <span>Limpar</span>
                              </v-tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-col>
                </v-container>
              </transition>
              <v-col cols="12" md="12" v-show="!!mensagem">
                <v-alert
                  style="cursor: pointer"
                  @click="mensagem = ''"
                  type="error"
                >
                  {{ mensagem }}
                </v-alert>
              </v-col>
              <v-col cols="12" md="12" class="text-right">
                <v-btn
                  color="sucess2"
                   class="mr-4 white--text"
                  :disabled="!valid || (erroEspecialidade && mostrarEpec)"
                  @click="validate"
                  >Prosseguir</v-btn
                >
              </v-col>
            </v-row>
          </v-card>
          <p class=" text-left new-subfonttittle2"><strong>Venha fazer parte!</strong></p>
          <p class=" text-left new-subfonttittle2">O credenciamento possibilita o atendimento a clientes das marcas que compõem o Grupo Odontoprev:</p>
        </v-container>
      </v-form>
      <Marcas style="margin-top: 20px !important;"/>
      <v-dialog v-model="dialogEtapaFinalizada" max-width="410">
        <v-card>
          <v-card-title class="label-f18"
            ><i
              class="fas fa-exclamation-circle"
              style="font-size: 24px; color: red"
            ></i>
            <span class="pl-2">Atenção</span>
          </v-card-title>
          <v-card-text>
            <p>
              Identificamos a indicação <strong>{{ cdIndicacao }}</strong> com
              os dados informados.
            </p>
            <p></p>
            <p>
              Caso não tenha recebido um retorno sobre sua indicação entre em
              contato conosco através do nosso canal de atendimento:
              <a href="https://www.odontoprev.com.br/dentista" target="_blank"
                >www.odontoprev.com.br/dentista</a
              >
              e informe o número acima.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="dialogEtapaFinalizada = false"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogForcarCadastro" max-width="410">
        <v-card>
          <v-card-title class="text-h5"> Atenção </v-card-title>
          <v-card-text>
            <p>Foi encontrada uma indicação com os dados informados.</p>
            <p></p>
            <p style="color: #0050e2">
              <i class="fa fa-check fa-fw mr-2"></i
              ><span v-html="descricaoConsultorioEncontrado"></span>
            </p>
            <p></p>
            <p>
              Clique em CONTINUAR para acessar a indicação encontrada, ou clique
              em NOVA INDICAÇÃO para criar uma nova indicação.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="novaIndicacao">
              Nova indicação
            </v-btn>
            <v-btn color="green darken-1" text @click="continuarIndicacao">
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialog" max-width="410">
        <v-card>
          <v-card-title class="text-h5"> Atenção </v-card-title>
          <v-card-text>
            <br />
            <p>Foi encontrado um cadastro para os dados informados.</p>
            <br />
            <p>
              Deseja continuar o preenchimento? (Nesse caso não será possível
              alterar as especialidades informadas)
            </p>
            <br />
            <p>
              Caso queira <strong>alterar as Especialidades</strong> clique em
              'ALTERAR CADASTRO'
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click="alterarCadastro">
              Alterar cadastro
            </v-btn>
            <v-btn color="green darken-1" text @click="continuarCadastro">
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogEtapaInvalidaToken" max-width="410">
        <v-card>
          <v-card-title class="text-h5"
            ><i
              class="fas fa-exclamation-circle"
              style="font-size: 24px; color: red"
            ></i>
            <span class="pl-2">Atenção</span>
          </v-card-title>
          <v-card-text style="font-weight: 700; padding-bottom: 0">
            <p>
              Indicação: <strong>{{ cdIndicacao }}</strong>
            </p>
            <p>Link inválido. Esse link não pode ser mais acessado.</p>
            <p style="margin: 0">
              Caso tenha dúvidas sobre o processo de credenciamento entre em
              contato conosco através do nosso canal de atendimento:
              <a href="https://www.odontoprev.com.br/dentista" target="_blank"
                >https://www.odontoprev.com.br/dentista</a
              >
              e informe a indicação acima.
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="dialogEtapaInvalidaToken = false"
            >
              Ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-main>
</template>

<script>
import Marcas from '@/components/Marcas.vue';
import { cpf } from 'cpf-cnpj-validator';
import { cnpj } from 'cpf-cnpj-validator';
import moment from 'moment';

export default {
  components: {
    Marcas,
  },
  data() {
    return {
      mensagem: '',
      show: false,
      selection: null,
      dialog: false,
      dialogEtapaFinalizada: false,
      dialogForcarCadastro: false,
      acaoDialogForcarCadastro: null,
      dialogEtapaInvalidaToken: false,
      forcarNovoCadastro: false,
      responseIndicacao: null,
      tipoDocumento: 'F',
      valid: true,
      nrCpf: '',
      nrCnpj: '',
      cep: '',
      dataNasc: '',
      passoIndic: '',
      cdIndicacao: null,
      mostrarEpec: false,
      descricaoConsultorioEncontrado: null,
      regrasCpf: this.getRegrasCpf(),
      regrasCep: this.getRegrasCep(),
      regrasDataNasc: this.getRegrasDataNasc(),
      obrigatorio: (v) => !!v || 'Preenchimento obrigatório',
      regrasCnpj: [],
      primeiraVerificacao: false,
      servicoBancoIndicacao: '/indicacao',
      especialidadesCertifBase64: [],
      especialidadesGeral: JSON.parse(
        JSON.stringify(this.$const.especialidadesGeral)
      ),
      especialidadesRadio: [
        {
          codigo: 14,
          titulo: 'Radiologia',
          valorSelecionado: null,
          grauInstrucao: null,
          certificado: null,
          base64: null,
          loading: false,
          incluiClinicoGeral: false,
        },
      ],
      especialidadesEmergencia: [
        {
          codigo: 18,
          titulo: 'Emergência',
          valorSelecionado: null,
          grauInstrucao: null,
          certificado: null,
          base64: null,
          loading: false,
          incluiClinicoGeral: false,
        },
      ],
      listaTipoClinica: [
        { codigo: 1, valor: 'Clí­nica Geral' },
        { codigo: 2, valor: 'Clí­nica de Emergência' },
        { codigo: 3, valor: 'Clí­nica de Radiologia' },
      ],
      tipoClinica: 1,
      especialidades: [], //this.especialidadesGeral,
      listaGrauInstrucao: this.$const.listaGrauInstrucao,
    };
  },
  computed: {
    erroEspecialidade() {
      return (
        !this.especialidades.find(
          (x) =>
            (x.valorSelecionado === 'E' && x.grauInstrucao != null) ||
            x.valorSelecionado === 'AA'
        ) &&
        this.primeiraVerificacao &&
        this.mostrarEpec
      );
    },
  },
  methods: {
    acertaEspecialidades() {
      this.limparEspecialidades();
      if (this.tipoClinica == 1) {
        this.especialidades = this.especialidadesGeral;
      } else if (this.tipoClinica == 2) {
        this.especialidades = this.especialidadesEmergencia;
      } else if (this.tipoClinica == 3) {
        this.especialidades = this.especialidadesRadio;
      }
    },
    continuarCadastro() {
      this.dialog = false;
      var indicacao = {
        passoSelecionado:
          this.responseIndicacao.passoAtual === null
            ? 1
            : this.responseIndicacao.passoAtual,
        passoAtual: this.responseIndicacao.passoAtual,
        modalidade: this.responseIndicacao.modalidade,
        cadastroDimensionado: this.responseIndicacao.cadastroDimensionado,
        listaEspecialidades: this.responseIndicacao.listaEspecialidades,
        passo1: this.responseIndicacao.passo1,
        passo2: this.responseIndicacao.passo2,
        passo3: this.responseIndicacao.passo3,
        passo4: this.responseIndicacao.passo4,
        passo5: this.responseIndicacao.passo5 || {
          listaCorpoClinico: [],
        },
        cdIndicacao: this.responseIndicacao.cdIndicacao,
        passoIndic: this.$route.params.passoIndic,
        emailItens: this.$route.params.emailItens,
      };
      
      if (indicacao.passo1.bairro) {
        indicacao.passo1.bairro = indicacao.passo1.bairro.codigo;
      }
      if (indicacao.passo1.tipoLogradouro) {
        indicacao.passo1.tipoLogradouro =
          indicacao.passo1.tipoLogradouro.codigo;
      }
      if (indicacao.passo4.tipoLogradouro) {
        indicacao.passo4.tipoLogradouro =
          indicacao.passo4.tipoLogradouro.codigo;
      }
      
      
      this.$router.push({ name: 'BancoIndicacoes', params: indicacao });
    },
    alterarCadastro() {
      this.dialog = false;
      this.showEspec();
    },
    novaIndicacao() {
      this.acaoDialogForcarCadastro = 'nova';
      
      this.showEspec();
      this.forcarNovoCadastro = true;
      this.dialogForcarCadastro = false;
    },
    continuarIndicacao() {
      this.acaoDialogForcarCadastro = 'continuar';
      
      let document = this.tipoDocumento == 'F' ? this.nrCpf : this.nrCnpj;
      
      this.buscarIndicacaoInciada(document, '');
      
      this.dialogForcarCadastro = false;
    },
    limparEspecialidades() {
      this.especialidades.forEach(function (espec) {
        espec.valorSelecionado = null;
        espec.grauInstrucao = null;
        espec.certificado = null;
      });
    },
    hideEspec() {
      this.mostrarEpec = false;
      this.limparEspecialidades();
    },
    showEspec() {
      this.mostrarEpec = true;
      setTimeout(() => {
        window.scrollTo({ top: 420, left: 0, behavior: 'smooth' });
      }, 300);
    },
    toogleDocumento() {
      if (this.tipoDocumento == 'F') {
        this.regrasCpf = this.getRegrasCpf();
        this.regrasCnpj = [];
      } else {
        this.regrasCpf = [];
        this.regrasCnpj = this.getRegrasCnpj();
      }
      this.hideEspec();
      this.nrCpf = '';
      this.nrCnpj = '';
      this.$refs.form.resetValidation();
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async convertBase64(espec) {
      espec.loading = true;
      if (espec.certificado) {
        espec.base64 = await this.getBase64(espec.certificado);
        espec.base64 = espec.base64.split('base64,')[1];
      }
      espec.loading = false;
    },
    validate() {
      this.primeiraVerificacao = true;
      if (this.$refs.form.validate()) {
        if (this.erroEspecialidade) {
          return;
        }
        this.validarIndicacao();
      }

      this.acertaEspecialidades();
    },
    convertEspecComCertificadoParaBase64() {
      this.especialidadesCertifBase64 = [];
      this.especialidades.forEach((item) => {
        if (item.valorSelecionado != null) {
          this.especialidadesCertifBase64.push({
            codigo: item.codigo,
            titulo: item.titulo,
            valorSelecionado: item.valorSelecionado,
            grauInstrucao: item.grauInstrucao,
            certificado: item.base64,
            incluiClinicoGeral: item.incluiClinicoGeral,
          });
        }
      });
    },
    async converterArquivosBase64(list) {
      var files = list;
      var listBase64 = [];
      const toBase64 = (file) =>
        new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
        });
      for (var i = 0; i < files?.length; i++) {
        var base64 = await toBase64(files[i]);
        listBase64.push(base64);
      }

      return listBase64;
    },
    buscarIndicacaoInciada(document, user) {

      this.mensagem = '';
      this.forcarNovoCadastro = false;
      this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);
      const dateSplit = this.dataNasc.split('/');
      const formatDataNasc =
        dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0];
      this.$http
        .get(
          `${this.servicoBancoIndicacao}?indicacao=` +
          this.cdIndicacao +
          `&documento=` +
            document +
            `&cep=` +
            this.cep +
            `&dataNasc=` +
            formatDataNasc +
            `&usuario=` +
            user
        )
        .then((response) => {
          if (response.data) {
            if (
              
              response.data.consultorioEncontrado &&
              !this.$route.params.passoIndic == 'DOC_PENDENTE'
            ) {
              this.descricaoConsultorioEncontrado =
                response.data.consultorioEncontrado.descricao;
              this.dialogForcarCadastro = true;
            } else {
              
               if (
                response.data.modalidade ==
                this.$modalidades.ATUALIZACAO_INDICACAO
                
              ) {
                
                this.responseIndicacao = response.data;
                this.responseIndicacao.passoAtual = 5;
                this.continuarCadastro();
              }
              
              else if (
                response.data.modalidade ==
                this.$modalidades.INDICACAO_FINALIZADA
              ) {
                
                this.cdIndicacao = response.data.cdIndicacao;
                this.dialogEtapaFinalizada = true;
              } else if (
                
                response.data.modalidade ==
                this.$modalidades.FINALIZADA_PRIMEIRA_ETAPA
              ) {
                
                this.cdIndicacao = response.data.cdIndicacao;
                this.dialogEtapaFinalizada = true;
              }  else {
                
                this.responseIndicacao = response.data;
                this.dialog = true;
              }
            }
          } else {
            
            this.showEspec();
          }
        })
        .catch((error) => {
          
              if (
                error &&
                error.response &&
                error.response.data &&
                error.response.data.message
              ) {
                this.mensagem = error.response.data.message;
              } else {
                this.mensagem = this.$msg.ERRO_INTERNO;
              }
            })
        .then(() => {
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
        });
    },
    checkIfIsLogged() {
      let token = localStorage.getItem('cod_consultor');
      return token && this.$route.name !== 'login';
    },
    validarIndicacao() {
      this.mensagem = '';

      let document = this.tipoDocumento == 'F' ? this.nrCpf : this.nrCnpj;

      const dateSplit = this.dataNasc.split('/');
      const formatDataNasc =
        dateSplit[2] + '-' + dateSplit[1] + '-' + dateSplit[0];
      const user = this.checkIfIsLogged()
        ? localStorage.getItem('user_name')
        : '';

      if (!this.mostrarEpec) {
        this.buscarIndicacaoInciada(document, user);
        return;
      }

      this.convertEspecComCertificadoParaBase64();

      const cdConsultor = this.checkIfIsLogged()
        ? localStorage.getItem('cod_consultor')
        : null;

      let indicacaoRequest = {
        tipoDocumento: this.tipoDocumento,
        documento: document,
        cep: this.cep,
        dataNasc: formatDataNasc,
        especialidades: this.especialidadesCertifBase64,
        cdConsultor: cdConsultor,
        novoCadastro: this.forcarNovoCadastro,
      };

      this.$eventBus.$emit(this.$const.EVENT_SHOW_LOADING);

      this.$http
        .post(`${this.servicoBancoIndicacao}/validar`, indicacaoRequest)
        .then((response) => {
          var indicacao = {
            
            passoSelecionado: response.data.passoAtual,
            passoAtual: response.data.passoAtual,
            tokenPassoIndic: this.passoIndic,
            modalidade: response.data.modalidade,
            cadastroDimensionado: response.data.cadastroDimensionado,
            listaEspecialidades: response.data.listaEspecialidades,
            passo1: response.data.passo1,
            passo2: response.data.passo2,
            passo3: response.data.passo3,
            passo4: response.data.passo4,
            passo5: response.data.passo5 || {
              listaCorpoClinico: [],
            },
          };
          if (indicacao.passo1.bairro) {
            indicacao.passo1.bairro = indicacao.passo1.bairro.codigo;
          }
          if (indicacao.passo1.tipoLogradouro) {
            indicacao.passo1.tipoLogradouro =
              indicacao.passo1.tipoLogradouro.codigo;
          }
          if (indicacao.passo4.tipoLogradouro) {
            indicacao.passo4.tipoLogradouro =
              indicacao.passo4.tipoLogradouro.codigo;
          }
          let path =
            this.$const.documentPath +
            document.replace(/\D/g, '') * this.$const.number;
          if (!localStorage.getItem(path)) {
            localStorage.setItem(path, JSON.stringify(indicacao));
          }
          this.$router.push({ name: 'BancoIndicacoes', params: indicacao });
        })
        .catch((error) => {
          if (error.response.data.message) {
            this.mensagem = error.response.data.message;
          } else {
            this.mensagem = this.$msg.ERRO_INTERNO;
          }
        })
        .then(() => {
          this.$eventBus.$emit(this.$const.EVENT_REMOVE_LOADING);
        });
    },
    getRegrasCpf() {
      return [
        (v) => !!v || 'O CPF é obrigatório',
        (v) => v.length <= 14 || 'O CPF deve ter menos de 14 caracteres',
        (v) => cpf.isValid(v) || 'O CPF é inválido',
      ];
    },
    getRegrasCnpj() {
      return [
        (v) => !!v || 'O CNPJ é obrigatório',
        (v) => v.length <= 18 || 'O CNPJ deve ter menos de 18 caracteres',
        (v) => cnpj.isValid(v) || 'O CNPJ é inválido',
      ];
    },
    getRegrasCep() {
      return [(v) => !!v || 'O CEP é obrigatório', this.exact(9)];
    },
    getRegrasDataNasc() {
      return [
        (v) => !!v || 'A data de nascimento é obrigatório',
        this.exact(10),
        (v) =>
          v?.length <= 9 ||
          moment(v, 'DD/MM/YYYY', true).isValid() ||
          'A data é inválida',
      ];
    },
    exact(i) {
      return (v) => v?.length == i || 'O campo deve ter ' + i + ' caracteres';
    },
    async buscarIndicacaoToken() {
      this.$http
        .get(`indicacao/token?token=${this.$route.query.token}`)
        .then((response) => {
          var indicacao = {
            cep: response.data.cep,
            documento: response.data.documento,
            tipoDocumento: response.data.tipoDocumento,
            dataNasc: response.data.dataNascimento,
            passoIndic: response.data.passoIndic,
            emailItens: response.data.emailItens,
          };

          this.cdIndicacao = response.data.cdIndicacao;

          if (
            ![3, 9, 12, 13, 15, 16].includes(response.data.codigoEtapa)
          ) {
            this.$router.replace({ query: undefined });
            this.dialogEtapaInvalidaToken = true;
            return;
          }

          if (response.data.passoIndic === 'ALT_ESPECIALIDADE') {
            this.$router.push({ name: 'Especialidades', params: indicacao });
          } else if (response.data.passoIndic === 'DOC_PENDENTE') {
            this.$router.push({ name: 'Home', params: indicacao });
          } else {
            this.$router.push({ name: 'Home', params: indicacao });
          }
        })
        .catch(() => {
          this.$router.push('/');
        });
    },
    handleRadioEspecialidadesChange(espec) {
      this.$nextTick(() => {
        espec.grauInstrucao = null;

        if (espec.valorSelecionado === 'E') {
          // Dar foco ao v-select
          this.$refs.selectGrauInstrucao.pop().focus();
          var comp = document.getElementsByClassName(
            'v-data-table__wrapper'
          )[0];
          comp.scrollLeft = 800;
        }
      });
    },
  },
  created: async function () {
    if (this.$route.query?.token) {
      await this.buscarIndicacaoToken();
    }

    this.$watch(
      () => this.$route.params,
      (toParams) => {
        var indicacao = toParams;

        this.acertaEspecialidades();

        if (Object.keys(indicacao).length !== 0) {
          this.cep = indicacao.cep;
          this.tipoDocumento = indicacao.tipoDocumento;
          this.dataNasc = indicacao.dataNasc;
          this.passoIndic = indicacao.passoIndic;

          if (this.tipoDocumento == 'F') {
            this.nrCpf = indicacao.documento;
          } else {
            this.nrCnpj = indicacao.documento;
          }

          this.forcarNovoCadastro = false;

          setTimeout(() => {
            this.validarIndicacao();
          }, 300);
        }
      }
    );
  },
};
</script>
<style scoped>

.cpf-style ::v-deep .v-text-field--outlined .v-input__control .v-input__slot {
  background: #FBFBFB !important;
  border-radius: 10px !important;
}

.cpf-style ::v-deep .v-text-field--outlined fieldset {
  border: 1px solid #707070 !important;
  border-radius: 10px !important;
}

tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

.container {
  @media (max-width: 576px) {
    padding: 0 !important;
  }
}

.container > div {
  @media (max-width: 576px) {
    border-radius: 0 !important;
    border-left: none;
    border-right: none;
  }
}

.componentEspec {
  @media (max-width: 576px) {
    padding: 0;
  }
}
</style>
